import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin, Button, message, Modal } from 'antd';
import TopInfo from '../../../basicElement/TopInfo';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import FundsUpdateView from './FundsUpdateView';
import { getMatchOption } from '../../../shared/selectFn';
import format from '../../../shared/format';

const STATUS = {
    add: {
        add: true,
        title: '添加请款预计跟踪',
    },
    edit: {
        edit: true,
        title: '更新请款预计跟踪表',
    },
    view: {
        view: true,
        title: '查看请款预计跟踪',
    },
};

class FundsUpdate extends Component {
    static contextTypes = {
        configure: PropTypes.object
    };
    
    constructor(props) {
        super(props);
        const { type } = props;
        this.config = STATUS[type];
        this.state = {
            data: {},
            loading: false,
            editable: !(this.config.view || this.config.confirm),
        };
    }

    componentDidMount() {
        if (!this.config.add) {
            this.loadDetail();
            // const {record} = this.props;
            // this.setState({ data:record })
        }
    }
     
    loadDetail = () => {
        const { record } = this.props;
        const { investigationId } = record;
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.queryRemittanceTraceDetail, {
            investigationId,
        }).then(res => {
            const { baUserIds } = res || {};
            this.setState({
                data:{...res, baUserIds: baUserIds ? baUserIds.split(',') : [] },
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleChange = (data) => {
        this.setState({ data });
    }

    handleSave = () => {
        //const { configure } = this.context;
        const { record } = this.props;
        const { data } = this.state;
        const { investigationId } = record;

        if (!data.nextInvoicePossibilityId) {
            return message.warning('请选择下月开票可能性判断');
        }
        if (!data.remittanceProcess) {
            return message.warning('请输入PM填写更新请款进度');
        }
        if (!data.keyBlockingId) {
            return message.warning('请输入当前卡脖子节点负责人');
        }
        const params = {
            nextInvoicePossibilityId:data.nextInvoicePossibilityId,
            remittanceProcess:data.remittanceProcess,
            keyBlockingId:data.keyBlockingId,
            baUserIds:data.baUserIds.join(','),
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.investigation.updateRemittanceTrace, {
            investigationId: investigationId || '',
            ...params,
        }).then(res => {
            const { error } = res;
            if(!error)
            {
                message.success('更新成功');
                this.setState({ loading: false }, () => {
                    this.props.update();
                });
            }
           
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    cancel = () => {
        const { record } = this.props;
        this.cancelRef.show(record);
    }

    render() {
        const { update, record } = this.props;
        const { data, loading, editable } = this.state;
        const { title, add, edit, confirm } = this.config;
        const { complaintRecordNumber } = record;
        const maxHeight = (document.body || document.documentElement).clientHeight - 258 - (editable || confirm ? 28 : 0);
        return (
            <div>
                <TopInfo
                    title={add || edit ? title : `${title}-${complaintRecordNumber}`}
                    onClick={() => update()}
                />
                <Spin spinning={loading}>
                    <div style={{ marginTop: 10, maxHeight, overflowX: 'hidden', overflowY: 'auto' }}>
                        <FundsUpdateView
                            data={data}
                            editable={editable}
                            onChange={this.handleChange}
                            viewCloumeDetail={this.props.viewCloumeDetail}
                        />
                    </div>
                </Spin>
                {
                    editable &&
                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                        <Button type="ghost" onClick={() => update()} disabled={loading}>取消</Button>
                        <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleSave} disabled={loading}>确定</Button>
                    </div>
                }
            </div>
        );
    }
}

export default FundsUpdate;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/FundsUpdate.js